import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Box } from '@fiverr-private/theme';
import { Stack } from '@fiverr-private/layout_components';
import { ResponsiveSpacingType } from '@fiverr-private/theme/dist/esm/src/components/Box/types';
import {
    imageStyleDu,
    imageStyleEn,
    imageStyleFr,
    imageStyleGr,
    imageStyleIt,
    imageStylePor,
    imageStyleSp,
} from './FaIndication.ve.css';

export interface AdIndicationProps {
    gap: ResponsiveSpacingType;
    addMargin?: boolean;
}
/* this style makes the Ad indication display. the naming is confusing to bypass adBlockers */
const styleMap = {
    'en-US': imageStyleEn,
    'fr-FR': imageStyleFr,
    'de-DE': imageStyleGr,
    es: imageStyleSp,
    'pt-BR': imageStylePor,
    'it-IT': imageStyleIt,
    'nl-NL': imageStyleDu,
};
const AdIndication = ({ gap, addMargin = false }: AdIndicationProps) => {
    const { locale } = getContext();
    const style = styleMap[locale] || imageStyleEn;
    const margin = addMargin ? '0.5' : '0';
    return (
        <Stack gap={gap} alignItems="center" marginBottom={margin}>
            <Box className={style} />
            <Box backgroundColor="grey_900" borderRadius="circle" width="4px" height="4px" />
        </Stack>
    );
};

export default AdIndication;
